// Swatch Filtering for Product Bundle Popup
// This script filters the Order Swatches popup to show only relevant swatches

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    mainFormSelector: 'form[action="/cart/add"]:not(#swatches form)',
    popupFormSelector: '#swatches form',
    popupId: 'swatches',
    variantOptionsSelector: '.option_value.color_swatch',
    swatchCheckboxSelector: '#swatches input[type="checkbox"]',
    bundleProductSelector: '.bundle_product',
    debugMode: false // Set to true for console logging
  };

  // Store main product fabrics globally so they persist when popup reopens
  let cachedMainFabrics = null;

  // Utility function for debug logging
  const debugLog = (...args) => {
    if (CONFIG.debugMode) {
      console.log('[Swatch Filter]', ...args);
    }
  };

  // Extract fabric name from various element types
  const extractFabricName = (element) => {
    // Try to get from sr-only span
    const srOnly = element.querySelector('.sr-only');
    if (srOnly) return srOnly.textContent.trim();

    // Try to get from title attribute
    if (element.title) return element.title.trim();

    // Try to get from alt text
    const img = element.querySelector('img');
    if (img && img.alt) return img.alt.trim();

    // Try to get from text content
    return element.textContent.trim();
  };

  // Normalize fabric names for comparison
  const normalizeFabricName = (name) => {
    return name.toLowerCase()
      .replace(/[^\w\s]/g, '') // Remove special characters
      .replace(/\s+/g, ' ')     // Normalize whitespace
      .replace(/\s+swatch$/i, '') // Remove "Swatch" suffix if present
      .trim();
  };

  // Check if two fabric names match
  const fabricNamesMatch = (name1, name2) => {
    const norm1 = normalizeFabricName(name1);
    const norm2 = normalizeFabricName(name2);

    debugLog(`Comparing: "${norm1}" vs "${norm2}"`);

    // Exact match
    if (norm1 === norm2) {
      debugLog('  → Match');
      return true;
    }

    // Check if one contains the other (for cases like "Performance Velvet Cypress" vs "Cypress")
    if (norm1.includes(norm2) || norm2.includes(norm1)) {
      debugLog('  → Contains match');
      return true;
    }

    debugLog('  → No match');
    return false;
  };

  // Get available fabric options from the main product form
  const getMainProductFabrics = () => {
    const fabrics = [];
    const mainForm = document.querySelector(CONFIG.mainFormSelector);

    if (!mainForm) {
      debugLog('Main product form not found');
      return fabrics;
    }

    // Find variant options (swatches)
    const variantOptions = mainForm.querySelectorAll(CONFIG.variantOptionsSelector);

    variantOptions.forEach(option => {
      const fabricName = extractFabricName(option);
      if (fabricName) {
        fabrics.push(fabricName);
        debugLog('Found main product fabric:', fabricName);
      }
    });

    return fabrics;
  };


  // Filter swatches in the popup
  const filterPopupSwatches = () => {
    const popup = document.getElementById(CONFIG.popupId);
    if (!popup) {
      debugLog('Popup not found');
      return;
    }

    // Use cached fabrics if available, otherwise get and cache them
    if (!cachedMainFabrics) {
      cachedMainFabrics = getMainProductFabrics();
      debugLog('Caching main product fabrics:', cachedMainFabrics);
    }

    const mainFabrics = cachedMainFabrics;
    debugLog('Using fabrics for filtering:', mainFabrics);

    // If no main fabrics found, show all swatches
    if (mainFabrics.length === 0) {
      debugLog('No main fabrics found, showing all swatches');
      const bundleProducts = popup.querySelectorAll(CONFIG.bundleProductSelector);
      bundleProducts.forEach(product => {
        product.style.display = '';
        product.setAttribute('data-swatch-available', 'true');
      });
      return;
    }

    // Find all bundle products in the popup
    const bundleProducts = popup.querySelectorAll(CONFIG.bundleProductSelector);
    let hiddenCount = 0;
    let visibleCount = 0;

    // First pass: identify what should be shown
    const swatchesToShow = [];
    const swatchesToHide = [];

    bundleProducts.forEach(product => {
      const label = product.querySelector('label');
      if (!label) return;

      // Check if this product should skip filtering
      if (product.hasAttribute('data-no-filter')) {
        const labelText = label.textContent.trim();
        debugLog('\n=== Skipping filter for:', labelText, '(has data-no-filter attribute)');
        swatchesToShow.push({ element: product, name: labelText, reason: 'no-filter tag' });
        return;
      }

      // Get fabric name from multiple sources (label might be "Default Title")
      const labelText = label.textContent.trim();
      const img = product.querySelector('img');
      const imgAlt = img?.alt?.trim() || '';

      // Use image alt text if label is "Default Title", otherwise use label
      const swatchName = (labelText === 'Default Title' && imgAlt) ? imgAlt : labelText;

      debugLog('\n=== Evaluating swatch:', swatchName);
      if (labelText === 'Default Title') {
        debugLog('  (Using image alt text instead of Default Title)');
      }

      // Check if this swatch matches any main product fabric
      let shouldShow = false;
      let matchedFabric = '';

      for (const mainFabric of mainFabrics) {
        if (fabricNamesMatch(mainFabric, swatchName)) {
          shouldShow = true;
          matchedFabric = mainFabric;
          break;
        }
      }

      if (shouldShow) {
        swatchesToShow.push({ element: product, name: swatchName, reason: `matches: ${matchedFabric}` });
      } else {
        swatchesToHide.push({ element: product, name: swatchName });
      }
    });

    // Second pass: apply visibility changes
    debugLog(`\nApplying visibility changes...`);

    swatchesToShow.forEach(({ element, name, reason }) => {
      element.style.display = '';
      element.setAttribute('data-swatch-available', 'true');
      visibleCount++;
      debugLog(`✓ Showing: ${name} (${reason})`);
    });

    swatchesToHide.forEach(({ element, name }) => {
      element.style.display = 'none';
      element.setAttribute('data-swatch-available', 'false');

      // Uncheck if checked
      const checkbox = element.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change'));
      }

      hiddenCount++;
      debugLog(`✗ Hiding: ${name}`);
    });

    debugLog(`\nSummary - Visible: ${visibleCount}, Hidden: ${hiddenCount}`);

    // List all visible swatches for verification
    if (visibleCount > 0) {
      debugLog('Currently visible swatches:');
      swatchesToShow.forEach(({ name }) => {
        debugLog(`  - ${name}`);
      });
    }
  };

  // Initialize when DOM is ready
  const initialize = () => {
    debugLog('Initializing swatch filter');

    // Wait a bit for any initial rendering
    setTimeout(() => {
      filterPopupSwatches();
    }, 100);

    // Re-filter when popup opens
    document.addEventListener('click', (e) => {
      if (e.target.matches('a[href="#swatches"]') || e.target.closest('a[href="#swatches"]')) {
        debugLog('Swatch popup link clicked');
        // Wait for popup to fully open
        setTimeout(filterPopupSwatches, 500);
        // Double-check after animation
        setTimeout(filterPopupSwatches, 1000);
      }
    });

    // Re-filter when variant changes
    const mainForm = document.querySelector(CONFIG.mainFormSelector);
    if (mainForm) {
      mainForm.addEventListener('change', (e) => {
        if (e.target.name === 'id' || e.target.closest(CONFIG.variantOptionsSelector)) {
          debugLog('Variant changed, refreshing cache and re-filtering');
          // Clear cache to force refresh when variant changes
          cachedMainFabrics = null;
          setTimeout(filterPopupSwatches, 100);
        }
      });
    }
  };

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();